module.exports = __webpack_public_path__ + "img/phoxDash.f285b77d.png";